import { Component, Input } from '@angular/core';
import image from '!!file-loader!./catalog_description_file.png';

@Component({
  selector: 'app-example-file-button',
  templateUrl: './example-file-button.component.html',
  styles: [
    `
      :host {
        display: flex;
      }
    `,
  ],
})
export class ExampleFileButtonComponent {
  @Input() hxid = '';
  image = image;

  get href(): string {
    return `/catalog/downloadexamplefile?hxid=${this.hxid}`;
  }
}
